var _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionCircleIcon = function SvgQuestionCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#707070",
    stroke: "#707070"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Rubik-Bold, Rubik",
    fontSize: 18,
    fontWeight: 700,
    transform: "translate(10.868 23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?"))));
};
export default SvgQuestionCircleIcon;